import { Link } from 'react-router-dom';

interface ArticleCard {
  title: string;
  path: string;
  excerpt: string;
  imageUrl: string;
  category: string;
}

const articleData: ArticleCard[] = [
  {
    title: 'Best Shoes Spreadsheet Guide',
    path: '/article/pandabuy-spreadsheet-shoes',
    excerpt: 'Discover Nike, Jordan, and designer sneaker finds organized with price comparisons and community quality ratings.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Pair%20of%20minimalist%20white%20and%20sand%20colored%20fashion%20sneakers%20on%20textured%20beige%20surface%20with%20soft%20side%20lighting%20clean%20editorial%20product%20photography%20warm%20neutral%20aesthetic&width=600&height=400&seq=grid-article-shoes-v2&orientation=landscape',
    category: 'Shoes',
  },
  {
    title: 'Hoodies & Sweaters Guide',
    path: '/article/pandabuy-spreadsheet-hoodies',
    excerpt: 'Explore oversized streetwear hoodies and designer-inspired knitwear with fabric weight and fit recommendations.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Folded%20cream%20oversized%20hoodie%20on%20warm%20wooden%20surface%20with%20morning%20sunlight%20casting%20gentle%20shadows%20minimalist%20fashion%20editorial%20photography%20soft%20natural%20tones&width=600&height=400&seq=grid-article-hoodies-v2&orientation=landscape',
    category: 'Hoodies',
  },
  {
    title: 'T-Shirts Style Guide',
    path: '/article/pandabuy-spreadsheet-t-shirts',
    excerpt: 'Find graphic tees, vintage styles, and oversized cuts with detailed fabric weight and print quality notes.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stack%20of%20neatly%20folded%20neutral%20tone%20cotton%20t-shirts%20in%20cream%20sage%20and%20charcoal%20on%20light%20wood%20surface%20soft%20diffused%20daylight%20minimalist%20wardrobe%20photography&width=600&height=400&seq=grid-article-tshirts-v2&orientation=landscape',
    category: 'T-Shirts',
  },
  {
    title: 'Jackets & Outerwear',
    path: '/article/pandabuy-spreadsheet-jackets',
    excerpt: 'Browse bomber jackets, winter coats, and windbreakers with insulation ratings and fit comparisons.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Olive%20bomber%20jacket%20draped%20over%20minimalist%20wooden%20chair%20in%20sunlit%20cream%20walled%20room%20with%20hardwood%20floor%20soft%20natural%20morning%20light%20editorial%20fashion%20photography&width=600&height=400&seq=grid-article-jackets-v2&orientation=landscape',
    category: 'Jackets',
  },
  {
    title: 'Luxury Bags Guide',
    path: '/article/pandabuy-spreadsheet-bags',
    excerpt: 'Discover designer-inspired handbags, totes, and crossbody bags with detailed material quality assessments.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Structured%20taupe%20leather%20handbag%20and%20cream%20canvas%20tote%20on%20light%20marble%20surface%20with%20gold%20accents%20soft%20window%20light%20luxury%20minimalist%20editorial%20photography&width=600&height=400&seq=grid-article-bags-v2&orientation=landscape',
    category: 'Bags',
  },
  {
    title: 'Accessories Collection',
    path: '/article/pandabuy-spreadsheet-accessories',
    excerpt: 'Sunglasses, watches, jewelry, and phone cases curated with community durability feedback and style notes.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Artistic%20arrangement%20of%20tortoiseshell%20sunglasses%20gold%20watch%20and%20delicate%20jewelry%20on%20textured%20linen%20with%20dried%20botanicals%20soft%20natural%20light%20editorial%20still%20life&width=600&height=400&seq=grid-article-accessories-v2&orientation=landscape',
    category: 'Accessories',
  },
  {
    title: 'Sports Jerseys',
    path: '/article/pandabuy-spreadsheet-jerseys',
    excerpt: 'Football kits, basketball jerseys, and retro team shirts with size charts and print quality reviews.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Colorful%20sports%20jerseys%20hung%20on%20wooden%20hangers%20against%20light%20grey%20wall%20athletic%20lifestyle%20editorial%20photography%20clean%20modern%20minimalist%20aesthetic&width=600&height=400&seq=grid-article-jerseys-v2&orientation=landscape',
    category: 'Jerseys',
  },
  {
    title: 'Streetwear Essentials',
    path: '/article/pandabuy-spreadsheet-streetwear',
    excerpt: 'Oversized fits, trending silhouettes, and urban fashion staples with community trend intelligence.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Trendy%20streetwear%20outfit%20elements%20hoodie%20denim%20and%20sneakers%20laid%20on%20concrete%20floor%20against%20white%20brick%20wall%20urban%20editorial%20fashion%20photography%20soft%20natural%20light&width=600&height=400&seq=grid-article-streetwear-v2&orientation=landscape',
    category: 'Streetwear',
  },
  {
    title: 'Trending Weekly Finds',
    path: '/article/pandabuy-spreadsheet-trending',
    excerpt: 'Stay ahead with viral TikTok and Reddit fashion finds, updated weekly with real-time popularity tracking.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dynamic%20fashion%20flatlay%20with%20colorful%20sneakers%20accessories%20and%20magazine%20pages%20on%20warm%20terrazzo%20surface%20bright%20modern%20editorial%20photography%20vibrant%20yet%20warm%20tones&width=600&height=400&seq=grid-article-trending-v2&orientation=landscape',
    category: 'Trending',
  },
];

export default function ArticleGridSection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">
            SEO Articles
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-2">
            PandabuySpreadsheet Guides
          </h2>
          <p className="text-foreground-600 text-sm max-w-[550px] mx-auto">
            In-depth guides covering every PandabuySpreadsheet category — written for fashion enthusiasts who want structured discovery with community-verified data.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {articleData.map((article) => (
            <Link
              key={article.path}
              to={article.path}
              className="group bg-white rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-300 hover:shadow-md transition-all cursor-pointer flex flex-col"
            >
              <div className="w-full h-[180px] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4 flex flex-col flex-1">
                <span className="text-xs text-primary-600 font-medium mb-1">{article.category}</span>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-foreground-500 text-xs leading-relaxed flex-1">
                  {article.excerpt}
                </p>
                <span className="inline-flex items-center gap-1 text-xs text-primary-600 font-medium mt-3 whitespace-nowrap">
                  Read Article
                  <i className="ri-arrow-right-line text-[10px]"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>

        {/* Also link to original guide */}
        <div className="text-center mt-8">
          <Link
            to="/article/pandabuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full border-2 border-secondary-300 text-secondary-700 text-sm font-semibold hover:bg-secondary-50 cursor-pointer whitespace-nowrap"
          >
            Complete 2026 PandabuySpreadsheet Guide
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}